export enum Paths {
    HOME = "/",
    TEST = "/test",
    DISCOVERY = "/discovery",

    /**
     * @deprecated
     */
    PACKAGED_INSIGHT_CREATION = "/domains/:domainId",

    ON_DEMAND_INSIGHT_CREATION = "/domains/:domainId/templates/:templateId",
    WORKBENCH = "/workbench",

    ALL_INSIGHTS = "/all-insights",
    ALL_INSIGHTS_BY_TYPE = "/all-insights/:insightType",
    YOUR_INSIGHTS = "/your-insights",
    YOUR_INSIGHTS_BY_TYPE = "/your-insights/:insightType",
    MARKETING_CONTENT = "/marketing-content",
    MARKETING_CONTENT_BY_TYPE = "/marketing-content/:contentType",

    DIMENSION_TESTING = "/dimensions-testing",
}
